var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.font)?_c('component-text',{key:_vm.font.id,attrs:{"font":_vm.font,"element":_vm.element,"preview-context":_vm.previewContext,"showTextBorder":_vm.showTextBorder}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }